export const STATE_LANDING_PAGE: string = "State_Landing_Page";
export const STATE_GAME: string = "State_Game";

export const LOAD_SPLASH: string = "Load_Splash";
export const LOAD_INTERSTITIAL: string = "Load_Interstitial";

export const SPRITESHEET_UI: string = "ui";
export const SPRITESHEET_GAME: string[] = ["game-0", "game-1"];
export const SPRITESHEET_INSTRUMENT_KEYBOARD: string = "instrument-keyboard";
export const SPRITESHEET_NOTE_PARTICLES: string = "note-particles";

export const FONT_GEL_LIGHT_22: string = "gelPenLight22";
export const FONT_GEL_MED_22: string = "gelPenMedium22";
export const FONT_GEL_MED_63: string = "gelPenMedium63";
export const FONT_LUNA: string = "lunaFont";
export const FONT_OUTLINED: string = "outlined-export";

export const TWEEN_ONCOMPLETE: string = "onComplete";
export const TWEEN_ONUPDATE: string = "onUpdate";

export const MIN_SCREEN_HALF_WIDTH: number = 600;

export const MUSIC_LAYER_TOP: string = "backing_loop_1";
export const MUSIC_LAYER_BASE: string = "backing_loop_0";

export const AUDIO_CATEGORY_SOLO: string = "AudioCategorySolo";

export const DEBUG_MINIMAL_AUDIO: boolean = false;
export const DEBUG_SKIP_LOAD: boolean = true;
export const DEBUG_DEFAULT_STATE: string | undefined = undefined; // STATE_GAME;
export const DEBUG_SKIP_ONBOARDING: boolean = false;
export const DEBUG_FAST_ONBOARDING: boolean = false;
